import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Label } from '../../../components/Label';
import { FormItem } from '../../../components/FormItem';
import type { InputDefaultProps } from '../types';
import { CustomInput } from './styles';

export function ReportName({ fieldName }: Readonly<InputDefaultProps>): JSX.Element {
	return (
		<Col span={24}>
			<Row gutter={[0, 10]}>
				<Col span={24}>
					<Label isRequired>{I18n.get('Report name')}</Label>
				</Col>
				<Col span={24}>
					<FormItem
						name={[fieldName, 'report_name']}
						rules={[{ required: true, message: I18n.get('Enter the report name') }]}
					>
						<CustomInput size="large" placeholder={I18n.get('Report name')} />
					</FormItem>
				</Col>
			</Row>
		</Col>
	);
}
